import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/bonificaciones-empleados';

/**
 * GET Bonificaciones Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getBonificacionesEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data?.results || response.data || [];
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Bonificacion Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postBonificacionEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Bonificación creada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Bonificacion Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchBonificacionEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/`, values);
    onSuccess(response, 'Bonificación actualizada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
